import { createCrudService } from "@dgs/core";
import { TeamCreateDto, TeamListDto, TeamOptionDto, TeamShowDto, TeamUpdateDto } from "apiGen";

export const teamService = createCrudService<TeamListDto, TeamOptionDto, TeamShowDto, TeamCreateDto, TeamUpdateDto>([
	"teams",
]);
